<div class="mt-2">
    <span [innerHTML]="body_text"></span>
</div>
